import styled from "styled-components";

interface RatingBagProps {
    width: string;
}

export const RatingBagContainer = styled.div`
    width: 100%;
    background: #D8D8D8;
    border-radius: 20px;
`

export const RatingBagActiveContainer = styled.div<RatingBagProps>`
    height: 100%;
    background: #96A83B;
    border-radius: 20px;
    width: ${(props) => (props.width)};
`

export const RatingBarStars = styled.div`
    display: flex;
    padding: 5px;

    img {
        margin: 0 6px;
    }
`